import { Connection, type ConnectionConfig } from "@solana/web3.js";
import { config } from "./types";

declare const __ADMIN_WALLET_RPC_URL__: string;
export function adminWalletRpcUrl(): string {
  const value = config.walletRpcUrl ?? (typeof __ADMIN_WALLET_RPC_URL__ === "string" ? __ADMIN_WALLET_RPC_URL__ : "");
  const url = new URL(value), host = config.environment === "prod" ? "mainnet.helius-rpc.com" : "devnet.helius-rpc.com";
  if (url.protocol !== "https:" || url.username || url.password || !(url.hostname === host || url.hostname.endsWith(`-${host}`))) throw Error("configured_helius_rpc_required");
  if (url.hostname === host && !url.searchParams.get("api-key")) throw Error("helius_rpc_credential_required");
  return value;
}
export const adminWalletRpcOptions: ConnectionConfig = { commitment: "confirmed", disableRetryOnRateLimit: true,
  fetch: (input, init) => fetch(input, { ...init, signal: init?.signal ? AbortSignal.any([init.signal, AbortSignal.timeout(8_000)]) : AbortSignal.timeout(8_000) }) };
export const adminWalletConnection = () => new Connection(adminWalletRpcUrl(), adminWalletRpcOptions);
